<div class="sponsorAd">
    <div class="d-none d-smb-2lock d-lg-none">
        <img src="https://moatsearch-data.s3.amazonaws.com/creative_screens/83/74/ad/8374ada9660f4178e3f790873d25db92.jpg" width="100%" alt="">
    </div>
    <div class="d-none d-lg-block text-center">
        <img src="https://d37p6u34ymiu6v.cloudfront.net/1-md5-30eb9b7101d5e4a4aa9acd14b30cdf36.jpg" width="100%" alt="" />
    </div>
</div>